import api from '../config/axiosConfig';

export const TipoPostulacionService = {
    getTipoPostulacion: async (token) => {
        try {
            const response = await api.get('/ajustes/tipopostulacion',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tipoPostulacion;
        } catch (error) {
            console.error('Error en TipoPostulacionService:', error);
            throw error;
        }
    },
};
